import { Component, OnInit } from '@angular/core';
import { AuthService, CommonService } from '../../services';
import { IUser, IUserModulePermission } from '../../models';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Constants } from '../../common';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
    selector: 'app-access-denied',
    imports: [
      MatButtonModule,
      MatTooltipModule
    ],
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent implements OnInit {


  isLoadingCompleted = false;

  constructor(private commonService: CommonService, private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
    this.commonService.getCurrentUserPermission().subscribe({
      next: (permissionData: IUserModulePermission) => {
        this.commonService.userPermission = permissionData?.permissions?.length > 0 ? permissionData.permissions : [];
        this.commonService.profileDetail = this.commonService.profileDetail ? this.commonService.profileDetail : {} as IUser;
        this.commonService.profileDetail.is_admin = permissionData?.is_admin;
        this.commonService.isPermissionLoaded = true;
        this.router.navigate([Constants.routingPaths.dashboard]);
      },
      error: (error: HttpErrorResponse) => {
        this.isLoadingCompleted = true;
        // console.log(error)
      }
    })
  }

  reloadPage() {
    window.location.reload();
  }

  logout() {
    this.authService.logout();
  }

}
